export const STORAGE_KEYS = {
  AUTH_TOKENS: 'lyt_auth_tokens',
  USER_DATA: 'lyt_user_data',
  SELECTED_ROLE: 'lyt_selected_role',
} as const;

export const storage = {
  get<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  },

  set<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  },

  remove(key: string): void {
    localStorage.removeItem(key);
  },
};
